import { useCostReportContext } from 'features/cost-report/hooks/useCostReportContext';
import { isDataProcessing } from 'features/cost-report/types/common';
import { useDataOrFixture } from 'hooks/useDataOrFixture';

export const useGpuUtilizationDataOrFixture = <T,>(
  data: T | undefined,
  fixture: () => Promise<T>
) => {
  const { hasGpuMetrics, hasGpuData, isCapabilitiesLoading, dataStatus } =
    useCostReportContext();
  const showFixture =
    !hasGpuMetrics &&
    !hasGpuData &&
    !isCapabilitiesLoading &&
    !isDataProcessing(dataStatus.gpu);

  return useDataOrFixture(data, fixture, showFixture);
};
